(() => {
  if (window.PuffleContentLoaded) return;
  window.PuffleContentLoaded = true;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const announce = (element, message) => {
    const status = element.closest('[data-copy-region]')?.querySelector('[role="status"]');
    if (!status) return;
    status.textContent = message;
    window.setTimeout(() => {
      status.textContent = '';
    }, 3000);
  };

  const copyText = async (button) => {
    const target = document.querySelector(button.dataset.copyTarget);
    if (!target) return;
    const value = target.textContent.trim();

    try {
      await navigator.clipboard.writeText(value);
      announce(button, button.dataset.copySuccess || 'Copied.');
    } catch (_error) {
      const range = document.createRange();
      range.selectNodeContents(target);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      announce(button, button.dataset.copyFallback || 'Select the code and copy it.');
    }
  };

  const revealHashTarget = () => {
    if (!window.location.hash) return;
    const target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (target instanceof HTMLDetailsElement) target.open = true;
  };

  ready(() => {
    document.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
      const group = opened.closest('[data-faq-group][data-single-open="true"]');
      if (!group) return;
      group.querySelectorAll('details[open]').forEach((item) => {
        if (item !== opened) item.open = false;
      });
    }, true);

    document.addEventListener('click', (event) => {
      const copyButton = event.target.closest('[data-copy-target]');
      if (copyButton) copyText(copyButton);

      const printButton = event.target.closest('[data-print]');
      if (printButton) window.print();
    });

    document.querySelectorAll('[data-qr-identifier]').forEach((container) => {
      if (typeof window.QRCode !== 'function') return;
      const identifier = container.dataset.qrIdentifier;
      if (!identifier) return;
      const panelStyles = window.getComputedStyle(container.closest('.p-gift-card__panel') || container);
      const foreground = panelStyles.getPropertyValue('--color-foreground').trim() || '#191715';
      const background = panelStyles.getPropertyValue('--color-background').trim() || '#fffdfb';
      new window.QRCode(container, {
        text: identifier,
        width: 144,
        height: 144,
        colorDark: foreground,
        colorLight: background,
        correctLevel: window.QRCode.CorrectLevel.H,
      });
      const qrImage = container.querySelector('img');
      if (qrImage) qrImage.alt = container.dataset.qrAlt || 'Gift card QR code';
    });

    revealHashTarget();
    window.addEventListener('hashchange', revealHashTarget);

    const formStatus = document.querySelector('[data-form-status]');
    if (formStatus instanceof HTMLElement) formStatus.focus({ preventScroll: true });
  });
})();
